import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Button, Typography } from "@bookips/sds";
import { useRouter } from "next/router";
import { useCountdown } from "../../hooks";
// 숫자를 최소 2자리 문자열로 변환 (3자리 이상은 그대로)
const formatTime = (value)=>String(value).padStart(2, "0");
export const MiniFreeTrialModule = (param)=>{
    let { className , isUsed =false , endTime , purchaseUrl , promotionId , promotionTitle , onCtaClick , onTimeUp  } = param;
    const router = useRouter();
    const { hours , minutes , seconds  } = useCountdown(undefined, onTimeUp);
    // MX-355: CTA 클릭 핸들러: purchaseUrl이 있으면 이동, 없으면 onCtaClick 호출
    const handleCtaClick = ()=>{
        mixpanelEvent("Free Trial Promotion CTA Button", {
            "Button URL": purchaseUrl || "",
            "Free Trial Promotion Id": promotionId || "",
            "Free Trial Promotion Title": promotionTitle || ""
        });
        if (purchaseUrl) {
            router.push(purchaseUrl);
        } else {
            onCtaClick === null || onCtaClick === void 0 ? void 0 : onCtaClick();
        }
    };
    // 남은 시간에 따라 basic/soon 자동 결정
    const isSoon = !isUsed && hours === 0 // 1시간 미만
    ;
    const isBasic = !isUsed && hours > 0 // 1시간 이상
    ;
    if (isUsed) {
        return /*#__PURE__*/ _jsxs("div", {
            className: cn("flex flex-col items-center gap-2 rounded-md bg-gray-50 px-3 py-4", className),
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "subtitle2",
                    className: "text-secondary",
                    children: "무료 혜택을 모두 사용했어요."
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "fill",
                    color: "primary",
                    size: "sm",
                    onClick: handleCtaClick,
                    className: "w-[140px]",
                    children: "즉시 무제한 이용하기"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex flex-col items-center gap-0.5 rounded-md p-3", "bg-mint-0 border-mint-200 border", className),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle2",
                className: "text-mint-500",
                children: "무료혜택 남은 시간"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cn("flex items-center justify-center gap-1 text-center", isSoon ? "text-status-error" : "text-strong"),
                children: [
                    isBasic && /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-center",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                className: "tabular-nums",
                                children: formatTime(hours)
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                children: "시간"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-center",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                className: "tabular-nums",
                                children: formatTime(minutes)
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                children: "분"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-center",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                className: "tabular-nums",
                                children: formatTime(seconds)
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                children: "초"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
